<template>
  <v-snackbar
    v-model="isVisible"
    v-bind="snackbar"
    class="core-snackbar"
  >
    {{ text }}

    <template
      v-if="action"
      #action="{ attrs }"
    >
      <v-btn
        v-bind="{ ...attrs, ...action }"
        @click="actionClick"
      >
        {{ action.btnText }}
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script setup lang="ts">
import useSnackbar from 'src/composables/useSnackbar'

const {
  isVisible,
  text,
  snackbar,
  action,
  actionClick,
} = useSnackbar()
</script>

<style lang="scss" scoped>
.core-snackbar {
  z-index: 10003; // Выше BaseDialog и SideMenu

  :deep(.v-snack__wrapper) {
    width: auto;
    min-width: 304px;
    bottom: 56px;
  }

  :deep(.v-snack__action) {
    margin-right: 8px;
  }
}
</style>
